<thm-data-loader #resimGetir path="profil/profil-resim-getir"
    [params]="{ profilId: profilId, girisYapanKullaniciId: kullaniciId }" (dataLoaded)="resimBasarili()"
    (errorOccurred)="resimHata($event)">
    <ng-template let-data>

        <div class="aday-bilgi">
            <!-- Resim -->
            <figure class="figure aday-resim">
                <img *ngIf="hataVarMi" [src]="'../assets/img/user-dummy.png'" alt="..."
                    class="img-thumbnail img-fluid" />
                <div *ngIf="!hataVarMi">
                    <img [src]="data.resim ? data.resim : '../assets/img/user-dummy.png'" alt="..."
                        class="img-thumbnail img-fluid" />
                    <a class="btn btn-light btn-block aday-resim-edit" (click)="resimGuncelle()" role="button">
                        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                    </a>
                </div>
            </figure>

            <!-- İsim + Profil Linki -->
            <div class="aday-isim">
                <span class="aday-ad-soyad">{{ adSoyad }}</span>
                <a class="aday-profil-link" (click)="resimGuncelle()">
                    <i class="fas fa-user-cog"></i>
                    {{ 'menu.profilim' | transloco }}
                </a>
            </div>
        </div>

    </ng-template>
</thm-data-loader>